export default __webpack_public_path__ + "static/media/middle.720440c7.png";